<td class="col-4" [ngClass]="{check:meta.formType === typeForm.checkbox}">
    <ng-container *ngIf="meta.formType === typeForm.checkbox">
        <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" [attr.id]="colIndex+meta.formType+meta.formDataKeyField" required>
            <label class="custom-control-label" [attr.for]="colIndex+meta.formType+meta.formDataKeyField">&nbsp;</label>
        </div>
    </ng-container>
</td>
